export const DriverType = [
    {
        name: "NAME #",
        selector: (row) => row["name"],
        sortable: true,
        center: true,
    },
    {
        name: "SUBSCRIPTION",
        selector: (row) => row["is_subscription"],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: "DELETED",
        selector: (row) => row["is_deleted"],
        sortable: true,
        center: true,
    },
]


export const DriverSchemeDeductionsColumns = [
    {
        name: "Driver Type",
        selector: (row) => row["driver_type"],
        sortable: true,
        // center: true,
        width:"180px",
    },
    {
        name: "Deduction Type",
        selector: (row) => row["deduction_type"],
        sortable: true,
        // center: true,
        width:"130px",
    },
    {
        name: "Deduction Value",
        selector: (row) => row["deduction_value"],
        sortable: true,
        // center: true,
        width:"130px",
    },
    {
        name: "Value Type",
        selector: (row) => row["value_type"],
        sortable: true,
        // center: true,
        width:"130px",
    },
    {
        name: "Value",
        selector: (row) => row["value"],
        sortable: true,
        // center: true,
        width:"100px",
    },
    {
        name: "Service City",
        selector: (row) => row["service_city"],
        sortable: true,
        // center: true,
        width:"180px",
    },
    {
        name: "Subscription",
        selector: (row) => row["is_subscription"],
        sortable: true,
        // center: true,
        width:"150px",
    },
       
    {
        name: "Calculation Type",
        selector: (row) => row["calculation_type"],
        sortable: true,
        // center: true,
        width:"150px",
    },
    {
        name: "Booking Type",
        selector: (row) => row["booking_type"],
        sortable: true,
        // center: true,
        width:"150px",
    },
    // {
    //     name: "Minimum Balance",
    //     selector: (row) => row["minimum_balance"],
    //     sortable: true,
    //     // center: true,
    //     width:"150px",
    // },
    // {
    //     name: "Applicable From",
    //     selector: (row) => row["applicable_from"],
    //     sortable: true,
    //     // center: true,
    //     width:"250px",
    // },
    // {
    //     name: "Applicable To",
    //     selector: (row) => row["applicable_to"],
    //     sortable: true,
    //     // center: true,
    //     width:"250px",
    // },
    {
        name: "DELETED",
        selector: (row) => row["Deleted"],
        sortable: true,
        // center: true,
        omit:true,
    },
    {
        name: "",
        selector: (row) => row["action"],
        sortable: true,
        // center: true,
        width: "50px",
    },
]

export const DriverTypeColumns = [
    {
        name: "Name",
        selector: (row) => row["name"],
        sortable: true,
    },
    {
        name: "Subscription",
        selector: (row) => row["subscription"],
        sortable: true,
    },
    {
        name: "City",
        selector: (row) => row["serviceCity"],
        sortable: true,
    },
    {
        name: "Minimum Balance",
        selector: (row) => row["minimumBalance"],
        sortable: true,
    },

    {
        name: "Applicable From",
        selector: (row) => row["applicableFrom"],
        sortable: true,
        width:"200px"
    },
    {
        name: "Applicable To",
        selector: (row) => row["applicableTo"],
        sortable: true,
        width:"200px"
    },
    {
        name: "Status",
        selector: (row) => row["status"],
        sortable: true,
        center: true,
        // omit:true
    },
    {
        name: "",
        selector: (row) => row["action"],
        sortable: true,
        // center: true,
        width: "50px",
    },
]